// Educated-guess default LoRA rank by dataset size. Rank is adapter capacity, and it must exceed the
// information in the dataset to match full fine-tuning (LoRA Without Regret, see PAPERS.md) — so
// bigger datasets get more rank, while small ones take less (cheaper, less overfitting). Clamped to
// the model's supported range; Together caps well below the paper's large-dataset ideal, so large
// datasets simply take the max. Refine the breakpoints as we gather evidence.
export function suggestedLoraRank(exampleCount: number, maxRank: number, minRank = 1): number {
    let rank: number
    if (!exampleCount || exampleCount <= 50) {
        rank = 16
    } else if (exampleCount <= 1000) {
        rank = 32
    } else {
        rank = 64
    }
    return Math.max(minRank, Math.min(rank, maxRank))
}
